import * as React from "react";
import PropTypes from 'prop-types';

const SvgTrackOrderNew = props => {
  if (props.id !== "_svgtrackordernew") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M6 12.918l4.667 1.705v8.381l3.5 1.643v-8.745l4.666 1.707v16.42L7.091 28.664A1.867 1.867 0 016 26.966V12.918zm28 0v14.046c0 .731-.426 1.395-1.091 1.699L21.167 34.03V17.609L34 12.918zM28.756 9.08l4.077 1.491L20 15.263l-4.106-1.502L28.756 9.08zm-9.397-2.966a1.867 1.867 0 011.282 0l3.01 1.1-12.863 4.68-3.621-1.323 12.192-4.457z" fillRule="evenodd" /></svg>;
};

SvgTrackOrderNew.displayName = "_svgtrackordernew";
SvgTrackOrderNew.propTypes = {
  id: PropTypes.string
};
SvgTrackOrderNew.defaultProps = {
  id: ''
};
export default SvgTrackOrderNew;